import getNamespacedObject from '@/store/utils/getNamespacedObject';
import namespace from './namespace';

export const byCompanyId = 'get/by-company-id';
export const withMissingUeFile = 'get/with-missing-ue-file';
export const withCodeOfConductStatus = 'get/with-code-of-conduct-status';

const getters = {
  byCompanyId,
  withMissingUeFile,
  withCodeOfConductStatus,
};

export const namespacedGetters = getNamespacedObject(namespace, getters);

export default getters;



// WEBPACK FOOTER //
// ./src/store/companyFiles/getterTypes.js